/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {useQuery} from '@tanstack/react-query'
import {useToast} from '../../../components/Toats'
import {useToastModal} from '../../../components/ToastModal'
import {getInvoicePDF, getInvoicesAll} from '../../../../services/invoices'
import {getplantsAll} from '../../../../services/plantsService'
import {getConcessionariesAll} from '../../../../services/concessionariesService'
import {getUnitConsumerAllFilter} from '../../../../services/unitConsumerService'
import {Loading} from '../../../components/Loadings/loading'
import {KTSVG} from '../../../../../_metronic/helpers'
import {ModalAddUpdateInvoice} from '../ModalAddEditInvoices'
import {InvoiceCard} from './InvoiceCard' // Ajuste o caminho se colocar em outro arquivo

type Props = {
  className: string
}

const TableInvoicesV2: React.FC<Props> = ({className}) => {
  const {toggleToast} = useToast()
  const {toggleToastModal} = useToastModal()

  // Estados de UI e Seleção
  const [loadingDownload, setLoadingDownload] = useState<boolean>(false)
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [myInvoice, setMyInvoice] = useState<any | null>(null)

  // Estados dos Filtros
  const [plantString, setPlantString] = useState<string>('')
  const [filterConcessionaries, setFilterConcessionaries] = useState<string>('')
  const [filterUnitConsumer, setFilterUnitConsumer] = useState<string>('')

  // Consultas na API
  const {data: plants = [], isLoading: loadingPlantsFilter} = useQuery<any[]>({
    queryKey: ['plantsFilterV2'],
    queryFn: async () => await getplantsAll(),
    staleTime: 1000 * 60 * 5,
  })

  const {data: concessionaries = [], isLoading: loadingConcessionaries} = useQuery<any[]>({
    queryKey: ['concessionariesV2'],
    queryFn: async () => await getConcessionariesAll(),
    staleTime: 1000 * 60 * 5,
  })

  // Estados Derivados (Garantem que sempre tenhamos um valor default se o filtro estiver vazio)
  const activePlant = plantString || plants?.[0]?.id || ''

  const {data: unitConsumers = [], isLoading: loadingUnit} = useQuery<any[]>({
    queryKey: ['unitConsumersV2', activePlant],
    queryFn: async () => await getUnitConsumerAllFilter(null, activePlant),
    enabled: !!activePlant, // Só dispara quando tiver uma usina ativa
    staleTime: 1000 * 60 * 5,
  })

  const activeUnitConsumer =
    unitConsumers.find((u: any) => u.id === filterUnitConsumer) || unitConsumers?.[0] || null

  const {
    data: invoices = [],
    isLoading,
    refetch,
  } = useQuery<any[]>({
    queryKey: ['invoicesFilterV2', filterConcessionaries, activePlant],
    queryFn: async () =>
      await getInvoicesAll(
        undefined,
        undefined,
        filterConcessionaries || undefined,
        activePlant || undefined,
        'INFORMADO'
      ),
    enabled: !!activePlant,
  })

  // Ações
  const handleDownloadPDF = async (event: React.MouseEvent, link_file: string | null) => {
    event.stopPropagation()
    if (!link_file) {
      toggleToast('Não há arquivo de fatura para download.', 'alert')
      return
    }

    try {
      setLoadingDownload(true)
      const myPDF = await getInvoicePDF(link_file)

      if (myPDF?.url) {
        toggleToastModal('Fatura pronta para download!', myPDF.url, 'success')
        window.open(myPDF.url, '_blank')
      } else {
        toggleToast('Fatura não encontrada.', 'error')
      }
    } catch (error) {
      console.error(error)
      toggleToast('Erro ao baixar fatura.', 'error')
    } finally {
      setLoadingDownload(false)
    }
  }

  const handleUpdateInvoice = (invoice: any) => {
    setMyInvoice(invoice)
    setShowCreateAppModal(true)
  }

  if (loadingPlantsFilter || isLoading || loadingConcessionaries || loadingUnit) {
    return (
      <div className='spinnerLoadingDashboard'>
        <Loading myClass='spinner-border spinnerDashboard' />
      </div>
    )
  }

  return (
    <div style={{paddingBottom: '1rem', overflow: 'auto', height: '65vh'}}>
      {/* Cabeçalho da Unidade Consumidora */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.7rem',
          marginBottom: '1.5rem',
          marginTop: '0.5rem',
        }}
      >
        <KTSVG
          path='/media/icons/duotune/general/gen001.svg'
          className='svg-icon-muted svg-icon-3hx'
        />
        <h3 className='card-title' style={{display: 'flex', flexDirection: 'column'}}>
          <span className='card-label fs-7'>{activeUnitConsumer?.name || 'Não identificado'}</span>
          <span className='text-muted mt-1 fw-semibold fs-8'>
            Nº {activeUnitConsumer?.contrato || '000000'}
          </span>
        </h3>
        <select
          className='form-select form-select-white form-select-sm'
          style={{width: '8rem'}}
          value={activeUnitConsumer?.id || ''}
          onChange={(e) => setFilterUnitConsumer(e.target.value)}
        >
          {unitConsumers.map((unit: any) => (
            <option key={unit.id} value={unit.id}>
              {unit.name}
            </option>
          ))}
        </select>
      </div>

      {/* Filtros de Concessionária e Usina */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          marginTop: '0.5rem',
          justifyContent: 'space-between',
        }}
      >
        <div style={{width: '100%'}}>
          <div className='me-0 dropdown'>
            <button
              className='btn btn-sm border border-gray-300 btn-light buttonFilterMark'
              type='button'
              data-bs-toggle='dropdown'
              style={{display: 'flex', gap: '1rem', width: '13rem'}}
            >
              <span style={{overflowX: 'auto', width: '15rem', whiteSpace: 'nowrap'}}>
                {filterConcessionaries || 'Concessionária'}
              </span>
              <i className='bi bi-three-dots fs-3'></i>
            </button>
            <div className='dropdown-menu dropdown-menu-start' style={{padding: '1rem'}}>
              <div
                className='card-toolbar'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '15rem',
                  width: '20rem',
                  overflowX: 'auto',
                }}
              >
                <a
                  className='btn btn-sm btn-color-muted btn-active btn-active-dark px-5 me-1 nav-item'
                  data-bs-toggle='tab'
                  style={{
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                  href='#'
                  onClick={() => setFilterConcessionaries('')}
                >
                  Selecione uma concessionária
                </a>
                {concessionaries.map((concessionarie: any) => (
                  <a
                    key={concessionarie.id || concessionarie.name}
                    className='btn btn-sm btn-color-muted btn-active px-5 me-1 nav-item'
                    style={{
                      display: 'flex',
                      gap: '1rem',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                    data-bs-toggle='tab'
                    href='#'
                    onClick={() => setFilterConcessionaries(concessionarie.name || '')}
                  >
                    <span style={{textAlign: 'start'}}>
                      {concessionarie.name || 'Não identificado'}
                    </span>
                    <span
                      className={`badge badge-${
                        concessionarie.status_mon_aut === 'MONITORADA'
                          ? 'success'
                          : concessionarie.status_mon_aut === 'EM MANUTENÇÃO'
                          ? 'info'
                          : 'danger'
                      } fs-9`}
                      style={{
                        height: '1.5rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {concessionarie.status_mon_aut || 'Não identificado'}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div>
          <select
            className='form-select form-select-white form-select-sm'
            value={activePlant}
            onChange={(e) => setPlantString(e.target.value)}
          >
            {plants.map((plant: any) => (
              <option key={plant.id} value={plant.id}>
                {plant.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Lista de Faturas */}
      <div className='card p-2 mt-5'>
        {invoices.length > 0 ? (
          invoices.map((invoice: any, index: number) => (
            <InvoiceCard
              key={invoice.id || index}
              invoice={invoice}
              loadingDownload={loadingDownload}
              onUpdate={handleUpdateInvoice}
              onDownload={handleDownloadPDF}
            />
          ))
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
            }}
          >
            <h3 className='card-title align-items-start flex-column pb-3 py-3'>
              <span className='text-muted mt-1 fw-semibold fs-5'>Não há faturas geradas!</span>
            </h3>
          </div>
        )}
      </div>

      <ModalAddUpdateInvoice
        show={showCreateAppModal}
        id={myInvoice?.id}
        data={myInvoice}
        handleClose={() => {
          setMyInvoice(null)
          setShowCreateAppModal(false)
          refetch()
        }}
      />
    </div>
  )
}

export {TableInvoicesV2}
